module.exports = __webpack_public_path__ + "static/media/img004.af575dc6.jpg";